import React from 'react'
import {
  TextField,
  Button,
  Stack,
  Typography,
  IconButton,
  InputAdornment,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { validationRules } from 'utils/validationRules'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { AuthStore } from '../store/AuthStore'

const LoginPage = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))
  const [error, setError] = React.useState('')
  const [showPassword, setShowPassword] = React.useState(false)

  const onSubmit = async (data) => {
    setError('')

    const e = await AuthStore.login(data.email, data.password)

    if (e) {
      setError(e.message)
    }
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      <Typography
        variant="h2"
        color="text.primary"
        sx={{
          textAlign: 'center',
          marginBottom: `${isLargeScreen ? '4rem' : '3.2rem'}`,
        }}
      >
        Авторизация
      </Typography>

      <Controller
        name="email"
        control={control}
        rules={validationRules.email}
        render={({ field }) => (
          <TextField
            {...field}
            label="Электронная почта"
            type="email"
            error={!!errors.email || !!error}
            helperText={errors.email?.message || ' '}
            fullWidth
            required
            sx={{ marginBottom: `${isLargeScreen ? '2.4rem' : '1.6rem'}` }}
            slotProps={{
              input: {
                style: {
                  background: theme.vars.palette.inputBackground,
                  borderRadius: '12px',
                },
              },
            }}
          />
        )}
      />

      <Controller
        name="password"
        control={control}
        rules={validationRules.password}
        render={({ field }) => (
          <TextField
            {...field}
            label="Пароль"
            type={showPassword ? 'text' : 'password'}
            error={!!errors.password}
            helperText={errors.password?.message || ' '}
            fullWidth
            required
            sx={{ marginBottom: `${isLargeScreen ? '1rem' : '0.2rem'}` }}
            slotProps={{
              input: {
                style: {
                  background: theme.vars.palette.inputBackground,
                  borderRadius: '12px',
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setShowPassword(!showPassword)
                      }}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
        )}
      />

      <Stack sx={{ gap: `${isLargeScreen ? '4rem' : '3.2rem'}` }}>
        <Typography variant="legendCaption" color="primary.main">
          <Link to={'/auth/restore'} style={{ textDecoration: 'none' }}>
            Забыли пароль?
          </Link>
        </Typography>

        <Button
          type="submit"
          variant="contained"
          sx={{ width: '21.6rem', alignSelf: 'center' }}
        >
          Войти
        </Button>
      </Stack>
    </form>
  )
}

export default LoginPage
